import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Sidebar, MobileSidebar } from '@/components/dashboard/sidebar'
import { Topbar } from '@/components/dashboard/topbar'
import { CommandMenu } from '@/components/dashboard/command-menu'
import { ShortcutsDialog } from '@/components/dashboard/shortcuts-dialog'

// The dashboard shell: sidebar, top bar, and the page content. _app.tsx renders it
// once around every page so it stays mounted while navigating.
export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen bg-background'>
            <a
                href='#konten'
                className='sr-only z-50 rounded-md bg-foreground px-3 py-2 text-sm font-medium text-background focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
            >
                Langsung ke konten
            </a>

            <Sidebar />

            <div className='flex min-w-0 flex-1 flex-col'>
                <Topbar />

                <main id='konten' tabIndex={-1} className='flex-1 px-4 py-6 outline-none sm:px-6 lg:px-8 lg:py-8'>
                    <div className='mx-auto w-full max-w-[1440px]'>
                        {children}
                    </div>
                </main>

                <footer className='px-4 pb-6 text-xs text-muted-foreground sm:px-6 lg:px-8'>
                    <div className='mx-auto flex w-full max-w-[1440px] flex-col gap-1 border-t pt-4 sm:flex-row sm:items-center sm:justify-between'>
                        <p>
                            Arunika, dasbor bisnis langganan. Data diperbarui 3 November 2026.
                        </p>
                        <p>
                            Semua nominal dalam Rupiah dan sudah termasuk PPN.
                        </p>
                    </div>
                </footer>
            </div>

            <MobileSidebar />
            <CommandMenu />
            <ShortcutsDialog />
        </div>
    )
}
